import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { countryUpdate, countryDetails, logOutApi } from '../../../Context/api';
import { countryValidation } from '../../../Context/validation';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';

const UseEditCountry = () => {
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    useEffect(() => {
        countryView()
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId,type:'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const countryView = () => {
        axios.post(countryDetails(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                countryEdit.setValues(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
            }
        })
    }
    const countryEdit = useFormik({
        initialValues: {
            code: '',
            name: ''
        },
        validationSchema: countryValidation,
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                code: values.code.trim(),
                id: id
            }
            setSpinner(true)
            axios.post(countryUpdate(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            }).catch(() => {
                toast.error(commonMessage.networkError)
            })
        }
    })
  return {
    spinner,
    countryEdit
  }
}

export default UseEditCountry